import type {AxiosProgressEvent} from "axios"

export const calculateUploadProgress = (
    progressEvent: AxiosProgressEvent,
    onProgress?: (progress: number) => void
): number => {
    if (progressEvent.total) {
        const percentCompleted = Math.round(
            (progressEvent.loaded * 50) / progressEvent.total
        )
        if (onProgress) onProgress(percentCompleted)
        return percentCompleted
    }
    return 0
}

export const startFakeProgress = (
    startFrom: number,
    onProgress?: (progress: number) => void
): number | null => {
    let currentProgress = startFrom
    const interval = setInterval(() => {
        if (currentProgress < 95) {
            const increment = (95 - currentProgress) / 10
            currentProgress += increment
            if (onProgress) onProgress(Math.round(currentProgress))
        } else {
            clearInterval(interval)
        }
    }, 500)

    return interval
}
